import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    showMenu: false
}

export const showMenuSlice = createSlice({
    name: 'showMenu',
    initialState,
    reducers: {
        closeMenu: (state) => {
            state.showMenu = false
        },
        toggleShow: (state) => {
            state.showMenu = !state.showMenu
        }
    },
})

export const toggleState = (state) => state.showMenu.showMenu;

export const { toggleShow, closeMenu } = showMenuSlice.actions

export default showMenuSlice.reducer
